export type VersionInfo = {
    Url: string;
    Version: string;
}